"use client";

import Link, { useLinkStatus } from "next/link";
import type { ComponentProps } from "react";
import ProductNavigationOverlay from "./ProductNavigationOverlay";

/**
 * `next/link` for product cards: same props and markup, plus the product
 * detail skeleton when the navigation is still pending after 120ms (the link
 * was clicked before its prefetch finished). Prefetched links navigate
 * instantly as before — `useLinkStatus` reports no pending state for them.
 * The overlay is portalled to <body>, so nothing is added inside the <a>.
 */
export default function ProductLink({ children, ...props }: ComponentProps<typeof Link>) {
  return (
    <Link {...props}>
      {children}
      <PendingOverlay />
    </Link>
  );
}

function PendingOverlay() {
  const { pending } = useLinkStatus();
  return <ProductNavigationOverlay active={pending} />;
}
